import { Injector, NgModule, runInInjectionContext } from '@angular/core';
import {
  CoreActionsTypes,
  CoreBackendIDs,
  CORE_BACKEND
} from '@bepatient/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { OnboardingApiMobiService } from './onboarding-api.mobi.service';
import { OnboardingApiService } from './onboarding-api.service';
import { OnboardingApiSmartService } from './onboarding-api.smart.service';
import { OnboardingEffects } from './onboarding.effects';
import {
  onboardingInitialState,
  onboardingReducer
} from './onboarding.reducer';

/**
 * Reset the onboarding feature state to its initial values on logout so stale
 * login/onboarding flags from a previous session (e.g. `accountDoesntExist`,
 * `email`, `password`) never leak into the next login attempt.
 *
 * Only the LOGOUT action triggers the reset; every other action is delegated to
 * the wrapped reducer unchanged, so no existing flow is affected. Logout is
 * never dispatched during an active onboarding/login step, so in-progress state
 * is not lost mid-flow.
 */
export function clearOnboardingStateOnLogout(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return (state, action) => {
    if (action.type === CoreActionsTypes.LOGOUT) {
      return reducer(onboardingInitialState, action);
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearOnboardingStateOnLogout];

export const createApiService = (injector: Injector) => {
  switch (injector.get(CORE_BACKEND)) {
    case CoreBackendIDs.SMART:
      return runInInjectionContext(
        injector,
        () => new OnboardingApiSmartService()
      );

    default:
      return runInInjectionContext(
        injector,
        () => new OnboardingApiMobiService()
      );
  }
};
@NgModule({
  imports: [
    StoreModule.forFeature(
      'onboarding',
      onboardingReducer as ActionReducer<any, any>,
      {
        initialState: onboardingInitialState,
        metaReducers
      }
    ),
    EffectsModule.forFeature([OnboardingEffects])
  ],
  providers: [
    {
      provide: OnboardingApiService,
      useFactory: createApiService,
      deps: [Injector]
    }
  ]
})
export class OnboardingStoreModule {}
